import React, { Component } from "react";
import Header from './Header'
import FilterBar from '../components/FilterBar'
import AccountDetails from './AccountDetails'
import {getAccounts} from '../services/BinderDropService';
import ImageOrInitial from "../components/ImageOrInitial";

const queryString = require('query-string');

class Accounts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accounts: [],
      activeAccounts:[]
    };
  }

  componentDidMount() {
    
   
    getAccounts().then((accounts) => {
      this.setState({accounts, activeAccounts:accounts.length > 50 ? accounts.slice(0, 50) : accounts});
    });

  }

  updateFilter = (e) =>{
    console.log(e.target.value);

    if(e.target.value){
      /****TODO can refine this */
      var activeAccounts = this.state.accounts.filter(account => account.name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1);
      this.setState({activeAccounts:activeAccounts.length > 50 ? activeAccounts.slice(0, 50) : activeAccounts});
    }
    else{
      this.setState({activeAccounts:this.state.accounts.length > 50 ? this.state.accounts.slice(0, 50) : this.state.accounts});
    }

  }

  render() {
    const _params = queryString.parse(this.props.location.search);

    if(_params.id){
      return(
        <AccountDetails id={_params.id} />
      )
    }
    return (
      <div>
        <Header title="Accounts"/>
        <FilterBar onUpdate={this.updateFilter} placeholderText="Filter accounts by name"/>
        <div className="card fullTable">
        {this.state.activeAccounts.map((account, index) => {
            return <a key={"account_"+account.companyId} className="tableRow" href={"/accounts?id="+account.companyId}>
              <ImageOrInitial image={account.imageUrl} className="searchItemLogo" name={account.name} />
              <span  className="searchItemName">{account.name}</span>
              <span  className="searchItemSecondary">{account.industry} • <b>{account.sector}</b> </span>
            </a>

        })}

        
        </div>
      </div>
    );
  }
}
 
export default Accounts;